"use client";
import React, { useState } from "react";
import AppContainer from "../appContainer";
import SelectableServiceBox from "../ui/selectableServiceBox";
import { servicesCategories } from "@/constants";
import { FlexBetween } from "../ui";
import { useTranslations } from "next-intl";
import { servicesCategoriesTitles } from "@/interfaces";

const ServiceCategorySelectorSection = () => {
  const [categories, setCategories] = useState(servicesCategories);
  const t = useTranslations("categories");
  const handleCategorySelect = (id: string) => {
    setCategories((prevCategories) =>
      prevCategories.map((item) => ({
        ...item,
        isSelected: item.id === id,
      })),
    );
  };

  return (
    <section className="relative z-30 mt-[-102px] mb-10 w-full sm:mb-20 lg:mt-[-111px] lg:mb-30 xl:mt-[-122px]">
      <AppContainer className="h-auto px-5 sm:px-8">
        <FlexBetween className="mx-auto w-full lg:px-4">
          {categories.map((item) => (
            <SelectableServiceBox
              {...item}
              category={t(item.category) as servicesCategoriesTitles}
              key={item.key}
              href={`services/#service-cat-${item.category}`}
              onClick={() => handleCategorySelect(item.id)}
            />
          ))}
        </FlexBetween>
      </AppContainer>
    </section>
  );
};

export default ServiceCategorySelectorSection;
